import { Box, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import CustomTable from "../../../common/tables/table";
import {
  ApplicantViewDto,
  StatusUpdateAuditHistoryDto,
} from "../../applicant/Models";

interface Props {
  applicant: ApplicantViewDto | undefined;
}
export default function StatusUpdateHistory({ applicant }: Props) {
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [page, setPage] = useState<number>(0);

  const columns = [
    "#",
    "Status From",
    "Status To",
    "Reason",
    "Change Date",
    "User",
  ];
  const createTableRows = () => {
    return (
      <>
        {applicant &&
          applicant.statusUpdateAuditHistory &&
          applicant.statusUpdateAuditHistory
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((record: StatusUpdateAuditHistoryDto, key: React.Key) => {
              return (
                <TableRow key={key}>
                  <TableCell>{parseInt(key.toString()) + 1}</TableCell>
                  <TableCell>{record.applicationStatusFrom.replace(/([A-Z])/g, " $1").trim()}</TableCell>
                  <TableCell>{record.applicationStatusTo.replace(/([A-Z])/g, " $1").trim()}</TableCell>
                  <TableCell>
                    {record.rejectReason
                      ? record.rejectReason
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {moment(record.changeDateTime).format("YYYY/MM/DD")}
                  </TableCell>
                  <TableCell>
                    {record.createdUser}
                  </TableCell>
                </TableRow>
              );
            })}
      </>
    );
  };

  return (
    <>
      {applicant && applicant.statusUpdateAuditHistory && (
        <Box sx={{marginLeft:-3, marginTop:2}}>
          <CustomTable
            columns={columns}
            data={applicant.statusUpdateAuditHistory}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
            rows={() => createTableRows()}
            page={page}
          />
        </Box>
      )}
    </>
  );
}
